var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { observable } from 'mobx';
import Color from 'color';
import Model from './Model';
import { getRandomColor } from '../data/Colors';
var LabelModel = /** @class */ (function (_super) {
    __extends(LabelModel, _super);
    /**
     *
     * @param data
     */
    function LabelModel(data) {
        if (data === void 0) { data = null; }
        return _super.call(this, data) || this;
    }
    LabelModel.prototype.initialize = function (data) {
        this.color = getRandomColor();
        this.description = '';
    };
    /**
     *
     * @param data
     */
    LabelModel.prototype.update = function (data) {
        var _this = this;
        if (!data)
            return;
        var keys = Object.keys(data);
        keys.map(function (key) {
            switch (key) {
                case 'labelId':
                    _this.id = data[key];
                    break;
                case 'labelName':
                    _this.name = data[key];
                    break;
                case 'labelDescription':
                    _this.description = data[key];
                    break;
                case 'color':
                    if (data[key] instanceof Color) {
                        _this.color = data[key];
                    }
                    else {
                        _this.color = new Color(data[key]);
                    }
                    break;
                default:
                    _this[key] = data[key];
            }
        });
    };
    /**
     *
     * @return {string}
     */
    LabelModel.prototype.getBorderColor = function (blackWhite) {
        if (blackWhite === void 0) { blackWhite = false; }
        if (blackWhite) {
            return this.color.isDark() ? '#ffffff' : '#000000';
        }
        else {
            return this.color.isDark() ? this.color.lighten(0.75) : this.color.darken(0.75);
        }
    };
    /**
     *
     * @return {string}
     */
    LabelModel.prototype.getTextColor = function (blackWhite) {
        if (blackWhite === void 0) { blackWhite = false; }
        if (blackWhite) {
            return this.color.isDark() ? '#ffffff' : '#000000';
        }
        else {
            return this.color.isDark() ? this.color.lighten(0.75).hex() : this.color.darken(0.75).hex();
        }
    };
    /**
     *
     * @return {string}
     */
    LabelModel.prototype.getHexColor = function () {
        return this.color.hex();
    };
    __decorate([
        observable
    ], LabelModel.prototype, "id", void 0);
    __decorate([
        observable
    ], LabelModel.prototype, "organisationId", void 0);
    __decorate([
        observable
    ], LabelModel.prototype, "name", void 0);
    __decorate([
        observable
    ], LabelModel.prototype, "description", void 0);
    __decorate([
        observable
    ], LabelModel.prototype, "color", void 0);
    __decorate([
        observable
    ], LabelModel.prototype, "order", void 0);
    return LabelModel;
}(Model));
export default LabelModel;
